import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "./Reveal";

const FAQ_ITEMS = [
  {
    q: "Qu'est-ce que SOLAMOVE ?",
    a: "SOLAMOVE est une semelle intérieure lestée actuellement en développement, pensée pour accompagner votre marche quotidienne.",
  },
  {
    q: "Quand SOLAMOVE sera-t-elle disponible ?",
    a: "Le produit est actuellement en phase de développement et de validation. Les personnes pré-inscrites seront informées en priorité de l'ouverture des commandes.",
  },
  {
    q: "Combien pèsera une semelle ?",
    a: "Le poids définitif est encore en cours de validation afin de trouver le meilleur équilibre entre charge, flexibilité et confort.",
  },
  {
    q: "La pré-réservation est-elle payante ?",
    a: "Non. Elle est gratuite et sans engagement.",
  },
  {
    q: "Puis-je déjà acheter SOLAMOVE ?",
    a: "Non. Les ventes ne sont pas encore ouvertes.",
  },
  {
    q: "Dans quelles chaussures pourrai-je utiliser SOLAMOVE ?",
    a: "La compatibilité définitive sera communiquée après validation du produit.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-28 sm:py-40">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-4">
        <Reveal><Overline>Questions fréquentes</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display uppercase tracking-tight leading-[1.02] text-4xl sm:text-5xl mt-6">
            Tout savoir avant le lancement.
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="border-t border-black/[0.08]">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-accordion-item-${i + 1}`} className="border-b border-black/[0.08]">
                <AccordionTrigger className="font-display text-left text-lg sm:text-2xl uppercase tracking-tight py-8 hover:no-underline hover:text-[#A8B89A] transition-colors duration-500">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#6E6A66] text-base leading-relaxed pb-8 max-w-2xl">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
